import { makeRuntime as t } from "@arcgis/lumina";
/*! All material copyright Esri, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
v4.32.14 */
const s = t({ defaultAssetPath: "https://js.arcgis.com/map-components/4.32/", hydratedAttribute: "hydrated" }), { customElement: a, getAssetPath: m, setAssetPath: o } = s;
export {
  a as c,
  m as g,
  s as r,
  o as s
};
